import React from "react";
import { Form, Input, Select } from "antd";
import { BENEFICIARY_RELATIONSHIPS } from "constants/insurance";
import { validateRequiredText } from "utils/insurance-validators";

/**
 * BeneficiarySection — collects beneficiary information for the insurance application.
 * Used inside a parent Ant Design Form; does not wrap its own Form element.
 *
 * Fields:
 * - beneficiaryFullName (1-100 chars, required)
 * - beneficiaryAddress (1-255 chars, required)
 * - beneficiaryRelationship (select, required)
 * - beneficiaryRelationshipOther (1-50 chars, required when relationship = "other")
 */
export default function BeneficiarySection() {
  return (
    <div>
      <h3>ผู้รับผลประโยชน์ (Beneficiary)</h3>

      <Form.Item
        label="ชื่อ-นามสกุล (Full Name)"
        name="beneficiaryFullName"
        rules={[
          { required: true, message: "กรุณากรอกชื่อ-นามสกุลผู้รับผลประโยชน์" },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateRequiredText(value, 1, 100)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกชื่อ-นามสกุลระหว่าง 1-100 ตัวอักษร")
              );
            },
          },
        ]}
      >
        <Input maxLength={100} placeholder="ชื่อ-นามสกุลผู้รับผลประโยชน์" />
      </Form.Item>

      <Form.Item
        label="ที่อยู่ (Address)"
        name="beneficiaryAddress"
        rules={[
          { required: true, message: "กรุณากรอกที่อยู่ผู้รับผลประโยชน์" },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateRequiredText(value, 1, 255)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกที่อยู่ระหว่าง 1-255 ตัวอักษร")
              );
            },
          },
        ]}
      >
        <Input.TextArea
          maxLength={255}
          rows={3}
          placeholder="ที่อยู่ผู้รับผลประโยชน์"
        />
      </Form.Item>

      <Form.Item
        label="ความสัมพันธ์ (Relationship)"
        name="beneficiaryRelationship"
        rules={[
          { required: true, message: "กรุณาเลือกความสัมพันธ์กับผู้เอาประกันภัย" },
        ]}
      >
        <Select placeholder="เลือกความสัมพันธ์">
          {BENEFICIARY_RELATIONSHIPS.map((rel) => (
            <Select.Option key={rel.value} value={rel.value}>
              {rel.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={(prev, cur) =>
          prev.beneficiaryRelationship !== cur.beneficiaryRelationship
        }
      >
        {({ getFieldValue }) =>
          getFieldValue("beneficiaryRelationship") === "other" ? (
            <Form.Item
              label="ระบุความสัมพันธ์ (Specify Relationship)"
              name="beneficiaryRelationshipOther"
              rules={[
                {
                  required: true,
                  message: "กรุณาระบุความสัมพันธ์",
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (validateRequiredText(value, 1, 50)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("กรุณากรอกความสัมพันธ์ระหว่าง 1-50 ตัวอักษร")
                    );
                  },
                },
              ]}
            >
              <Input maxLength={50} placeholder="ระบุความสัมพันธ์อื่นๆ" />
            </Form.Item>
          ) : null
        }
      </Form.Item>
    </div>
  );
}
